interface SectionTitleProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  mark?: string;
}

export default function SectionTitle({ title, subtitle, align = 'left', mark }: SectionTitleProps) {
  return (
    <div className={`mb-8 md:mb-10 ${align === 'center' ? 'text-center' : ''}`}>
      <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`}>
        {mark && (
          <span className="font-seal rounded-md bg-primary-100 px-2.5 py-1 text-base text-primary-700">{mark}</span>
        )}
        <h2 className="font-heading text-2xl font-bold tracking-wide text-foreground-950 md:text-3xl">{title}</h2>
      </div>
      {subtitle && (
        <p
          className={`mt-3 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base ${
            align === 'center' ? 'mx-auto' : ''
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}